import React, { useContext, useMemo } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import RouteGuard, { RenderDashboard } from "RouteGuard";
import Join from "components/Join";
import Login from "components/auth/Login";
import Password from "components/auth/RecoverPassword";
import PricingTable from "components/PricingTable";
import ResetPass from "components/auth/ResetPassword";
import ServiceModeBanner from "components/ServiceModeBanner";
import CheckYourEmail from "components/common/CheckYourEmail";
import Confirm from "components/email/Confirm";
import RegisterBasic from "components/register/RegisterBasic";
import RegisterInvited from "components/register/RegisterInvited";
import RegisterPremierUser from "components/register/RegisterPremierUser";
import NotFound from "components/NotFound";
import allRoutes, { delegateUserRoutes } from "routes";
import Home from "components/Home";
import CancellationPolicy from "components/pages/CancellationPolicy";
import AccountCreation from "components/auth/ClientRegistration/AccountCreation";
import RequestDemoForm from "components/homeRedesign/RequestDemoForm";
import MyRepCares from "components/MyRepCares";
import { UserContext } from "components/context/UserContext";
import "components/client/dashboard/profile/Cards/cards.css";
import { ROLE_NAMES } from "helpers/common";
import ReferralsButton from "components/rep/referral/ReferralsButton";
import DelegateRouteGuard from "DelegateRouteGuard";

const AppRouter = () => {
  const { state } = useContext(UserContext)!;
  const location = useLocation();
  const { currentUser } = state;
  const isRep = useMemo(
    () =>
      [ROLE_NAMES.BASIC, ROLE_NAMES.PLUS, ROLE_NAMES.PREMIER].includes(
        currentUser?.roleName
      ),
    [currentUser]
  );
  const showFab = useMemo(() => {
    const isBannedLocation = ["/login", "/register", "/chat", "/chat/*"].some(
      (p) => location.pathname.includes(p)
    );

    return currentUser?.id && !isBannedLocation;
  }, [currentUser, location]);

  return (
    <>
      <ServiceModeBanner />
      <Switch>
        {allRoutes.map((route, i) => (
          <RouteGuard key={route.path + i} {...route}>
            <Route {...route} />
          </RouteGuard>
        ))}
        <Route path={"/"} exact render={() => <Home />} />
        <Route path={`/password`} component={Password} />
        <Route path={`/reset/:token`} component={ResetPass} />
        <Route path={`/register`} exact component={Join} />
        <Route path={`/join-platform/:token`} component={RegisterInvited} />
        <Route path={`/rep/premier`} component={RegisterPremierUser} />
        <Route path={`/client`} exact component={AccountCreation} />
        <Route path={`/rep/basic`} component={RegisterBasic} />
        <Route path={"/check/email"} component={CheckYourEmail} />
        <Route path={`/pricing`} component={PricingTable} />
        <Route path={`/confirm/:token`} component={Confirm} />
        <Route path={`/login`} component={Login} />
        <Route path={`/request-demo`} component={RequestDemoForm} />
        <Route
          path={`/subscription-renewal-cancellation-policy`}
          component={CancellationPolicy}
        />
        {delegateUserRoutes.map((route, i) => (
          <DelegateRouteGuard key={route.path + i} {...route}>
            <Route {...route} />
          </DelegateRouteGuard>
        ))}
        {/* <Route
          path={`/impersonation-options`}
          component={ImpersonationOptions}
        />
        <Route path={`/delegate/calendar`} component={DelegateCalendar} /> */}

        <Route
          path="*"
          component={() => (
            <RenderDashboard>
              <NotFound />
            </RenderDashboard>
          )}
        />
      </Switch>
      <div className="fab-container">
        {showFab && <MyRepCares />}
        {isRep && showFab && <ReferralsButton />}
      </div>
    </>
  );
};

export default AppRouter;
